import { render, staticRenderFns } from "./FileInput.vue?vue&type=template&id=5c2b32a4&scoped=true"
import script from "./FileInput.vue?vue&type=script&lang=ts"
export * from "./FileInput.vue?vue&type=script&lang=ts"
import style0 from "./FileInput.vue?vue&type=style&index=0&id=5c2b32a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2b32a4",
  null
  
)

export default component.exports